import apiClient from '../api/apiClient'
import type {
    ScopeInstance,
    ScopeInstanceFilters,
} from '../types/admin'

const BASE_PATH = '/admin/scope-instances'

const sanitise = (value: string | number, label: string): string => {
    const trimmed = String(value).trim()
    if (!trimmed) {
        throw new Error(`${label} is required`)
    }
    return trimmed
}

const getSpecificRoute = (route: string, ...args: (string | number)[]) => {
    // Simple replacement or appending logic if needed, but here we just need specific endpoints.
    // The original used a helper. We can just use string interpolation.
    return route
}

const ensureValue = (value: string, label: string): string => {
    const trimmed = value.trim()
    if (!trimmed) {
        throw new Error(`${label} is required`)
    }
    return trimmed
}

export const scopeInstanceService = {
    async getById(id: string): Promise<ScopeInstance> {
        const scopeInstanceId = ensureValue(id, 'Scope instance id')
        const { data } = await apiClient.get<ScopeInstance>(
            `${BASE_PATH}/${sanitise(scopeInstanceId, 'Scope instance id')}`
        )
        return data
    },

    async getHrHeads(scopeInstanceId: string): Promise<any[]> {
        const id = ensureValue(scopeInstanceId, 'Scope instance id')
        const { data } = await apiClient.get<any[]>(
            `/admin/scope-instances/${id}/hr-heads`,
        )
        return data
    },
}
